(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'ui-leaflet',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('ServicoCatalogoPesquisaController', ['$scope', '$state', '$location', 'toastr', 'API_ROOT', '$http', '$uibModal',
      function($scope, $state, $location, toastr, API_ROOT, $http, $uibModal)
  {
    var vm = this;
    vm.tipoParam = $state.params.tipo;
    vm.filtro = {tipo: 0};

    vm.init = function()
    {        
      vm.s_subdomain();      
    }

    vm.s_subdomain = function()
    {
        var host = $location.host();
        
        if (host.indexOf('.') < 0) 
        {
          vm.subdomain = _teste;          
        }
        else
        {
          var subdomain = host.split('.')[0];

          if (subdomain != '')
          {
            vm.subdomain = subdomain;
          }
        }

        if (vm.subdomain != null && vm.subdomain != '')
        {          
          vm.listarProdutos(vm.subdomain);
        }
    }

    vm.listarProdutos = function(subdomain)
    {
      vm.registros = null;
      vm.registrosOriginal = null;

      vm.consultaPromise = $http.get(API_ROOT + "/catalogoweb/produtos/" + subdomain)
      //vm.consultaPromise = $http.get(API_ROOT + "/catalogoweb/produtos")
      .then(function(response)
      { 
        vm.registrosOriginal = response.data;

        for(var i=0; i<vm.registrosOriginal.length; i++) {
          if (vm.registrosOriginal[i].fotoUrl == null || vm.registrosOriginal[i].fotoUrl == '')
          {
            vm.registrosOriginal[i].fotoUrl = 'assets/images/icons/produto.png';
          }
          //vm.registrosOriginal[i].foto = (API_ROOT + "/catalogoweb/ConsultarProdutoFoto/" + vm.registrosOriginal[i].viewId);
        }        

        vm.registros = vm.registrosOriginal;
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.texto != null && vm.filtro.texto != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.texto.toUpperCase()))
              {
                  incluir = false;
              }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '' && vm.filtro.tipo != '0')
            {
              if (vm.filtro.tipo != vm.registrosOriginal[i].tipo)
              {
                  incluir = false;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', '$location', 'toastr', '$cookieStore', 'API_ROOT', '$http',
  function ($state, $location, toastr, $cookieStore, API_ROOT, $http) {

    var vm = this;
    vm.subdomain = '';

    vm.init = function()
    {
        vm.s_subdomain();
    }

    vm.s_subdomain = function()
    {
      var host = $location.host();
        
      if (host.indexOf('.') < 0) 
      {
        vm.subdomain = _teste;
      }
      else
      {
        var subdomain = host.split('.')[0];

        if (subdomain != '')
        {
          vm.subdomain = subdomain;
        }
      }

      if (vm.subdomain != null && vm.subdomain != '')
      {          
        vm.consultarEmpresa(vm.subdomain);
      }
    }

    vm.consultarEmpresa = function(subdomain)
    {      
        vm.consultaPromise = $http.get(API_ROOT + "/catalogoweb/empresa/" + subdomain)
        .then(function(response)
        { 
          vm.empresa = response.data;
        });
    }

    vm.init();

    /*
    vm.usuario = {};     
    vm.default = '';

    vm.userName = AuthService.getUser();
    vm.empresaName = AuthService.getEmpresa();
    vm.testeuser = 'teste 123'

    vm.init = function()
    {
      if ($cookieStore.get('lastLogin') != null)
      {
        vm.usuario.Login = $cookieStore.get('lastLogin');
      }
    }

    vm.init();

    vm.login = function()
    {
      if (vm.usuario.Login == null || vm.usuario.Login == '')
      {
          toastr.error('Informe o Login da empresa.', 'Login');
          return;
      }

      if (vm.usuario.Senha == null || vm.usuario.Senha == '')
      {
          toastr.error('Informe a Senha.', 'Login');
          return;
      }
     
      $cookieStore.put('lastLogin', vm.usuario.Login);

      vm.loginPromise = vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha);

      vm.loginPromise.then(function(result) {  
          if(result.data.error == null && result.data.authenticated)
          {
              vm.default = result.data.default;

              vm.userName = AuthService.getUser();
              //vm.empresaName = AuthService.getEmpresa();
              //vm.menus = AuthService.getMenu();
              //vm.role = AuthService.getRole();      

              $state.go("index.main");
          }
          else
          {
              toastr.error("Login e/ou senha inválidos.", 'Login');
          }
      });
    }

    vm.realizarLogin = function(login, pwd){
      var data = {
          login: login,
          senha: pwd
      }
      return $http.post(API_INTRANET + "/usuario/login", data).then(
          function(response){
              AuthService.setToken(response.data.accessToken);
              AuthService.setUser(response.data.userName);
              //AuthService.setEmpresa(response.data.empresa);
              //AuthService.setRole(response.data.role);
              return response;
          },
          function (error) {
              return error;
          }
      )
    }
    */

  }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$uibModal', 'AuthService', 
  function ($state, $scope, toastr, $uibModal, AuthService) {

    var vm = this;

    /*
    vm.init = function()
    {
      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();

      vm.indicadoresPromise = AntecipacaoService.getIndicadoresPrincipal();

      vm.indicadoresPromise.then(function(result) {  
        if (result.status)
        {
          vm.indicadores = result.data;
        }
      });

      vm.operacoesPendentesPromise = AntecipacaoService.listarPendentes();

      vm.operacoesPendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.operacoesPendentes = result.data;
        }
      });
    }

    vm.modalDetalheSolicitacao = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/home/modal/detalhesSolicitacao.html',
        controllerAs: 'arquivoInfo',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
         }
      });
    }

    vm.consultarPendentes = function()
    {
      vm.pendentesPromise = AntecipacaoService.getPendentes();

      vm.pendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.pendentes = result.data;
        }
      });
    }

    vm.init();
    */
   
  }]);

'use strict';

angular.module('inspinia')
  .controller('LoginAppController', ['$scope', '$compile', '$state', 'toastr', 'API_INTRANET', '$http', '$uibModal', '$window',
      function($scope, $compile, $state, toastr, API_INTRANET, $http, $uibModal, $window)
  {
    var vm = this;
    vm.registro = {
      tipoAcesso: '1'
    };
    vm.statusTela = 1;

    vm.init = function()
    {
        
    }

    vm.enviar = function()
    {
      if (vm.registro.usuarioRede == null || vm.registro.usuarioRede == '')
      {
        toastr.error('Informe o seu Usuário de Rede.', 'Alerta');  
        return;
      }

      $state.go('index.home');
      //vm.statusTela = 2;
      /*
      vm.registro.tipoEmpresa = parseInt(vm.registro.tipoEmpresa);

      vm.salvarPromise = $http.post(API_INTRANET + "/cliente/precadastro", vm.registro).success(function(response){        
        toastr.info('Solicitação enviada com sucesso.', 'Ticket');
        vm.registro = {};

        vm.statusTela = 3;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      */
    }

    vm.validarAcesso = function()
    {
      $state.go('index.home');
    }

    vm.voltarInicio = function()
    {
      vm.statusTela = 1;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
angular
.module('inspinia').factory("HomeService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        getQuantidade: function () {
            return $http.get(APP_ROOT + "/home/GetQuantidade")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAtendimentosMapa: function () {
            return $http.get(APP_ROOT + "/home/GetAtendimentosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getContatosMaps: function () {
            return $http.get(APP_ROOT + "/home/GetContatosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider


      // Index
      .state('i', {
        abstract: true,
        url: "/i",
        templateUrl: "app/components/common/content.html"
      })

      /*
      .state('index.login', {
        url: "/login",
        templateUrl: "app/login/index.html",
        controller: 'LoginAppController',
        controllerAs: 'controller',
      })
      */
      .state('i.h', {
        url: "/h/:tipo",
        templateUrl: "app/home/servico/index.html",
        controller: 'ServicoCatalogoPesquisaController',
        controllerAs: 'controller',
        params: {
          tipo: 'null'
        }
      })
      /*
      .state('index.home2', {
        url: "/home2",
        templateUrl: "app/home/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('index.ticket_projetobi', {
        url: "/ticket_projetobi",
        templateUrl: "app/ticket/custom/projeto_bi/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })

      // Novo Ticket
      .state('index.novo_ticket', {
        url: "/novo_ticket",
        templateUrl: "app/ticket/novo/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('index.sucesso_ticket', {
        url: "/sucesso_ticket",
        templateUrl: "app/ticket/novo/sucesso.html",
        controller: 'TicketSucessoController',
        controllerAs: 'controller',
        params: {
          numero: null,
          nome: null
        }
      })

      // Consultar Ticket
      .state('index.consultar_ticket', {
        url: "/consultar_ticket",
        templateUrl: "app/ticket/consultar/index.html",
        controller: 'TicketConsultaController',
        controllerAs: 'controller',
      })

      // Requisicao de projetos
      .state('index.requisitar_projeto', {
        url: "/requisitar_projeto",
        templateUrl: "app/gpe/requisicao/index.html",
        controller: 'RequisicaoProjetoController',
        controllerAs: 'controller',
      })

       // Catalogo de servicos
       .state('index.servico_catalogo', {
        url: "/servico_catalogo",
        templateUrl: "app/servico/catalogo/index.html",
        controller: 'ServicoCatalogoPesquisaController',
        controllerAs: 'controller',
      })
            // landing
      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        data: { pageTitle: 'Landing page', specialClass: 'landing-page' }
      })

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      // REGISTRAR
      .state('portal', {
        abstract: true,
        url: "/portal",
        templateUrl: "app/minor/minor.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('portal.home', {        
        url: "/home",        
      })

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })
      */
      /*
      // Cedente
      .state('index.cadastrar_cedente', {
        url: "/cadastrar_cedente",
        templateUrl: "app/cedente/cadastrar.html",
        controller: 'CedenteCadastroController',
        controllerAs: 'controller'
      })
      .state('index.pesquisar_cedente', {
        url: "/pesquisar_cedente",
        templateUrl: "app/cedente/pesquisar.html",
        controller: 'CedentePesquisarController',
        controllerAs: 'controller'
      })
      .state('index.consultar_cedente', {
        url: "/consultar_cedente/:viewId",
        templateUrl: "app/cedente/consultar.html",
        controller: 'CedenteConsultarController',
        controllerAs: 'controller',
        params: {
          viewId: null
        }
      })

      // Usuarios
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'usuarioAlteracaoSenha',
        data: { pageTitle: 'Alterar Senha' }
      });
      */
      $urlRouterProvider.otherwise('/i/h/home');
      //$urlRouterProvider.otherwise('/index/login');
  }

})();

var _teste = 'teste';

angular
.module('inspinia')
.factory('PagerService', PagerService)

//.constant('API_ROOT', "http://192.168.15.89/contasapp/api")
//.constant('API_ROOT', "http://localhost:5000/api")
//.constant('API_ROOT', "https://contasapp.b2desk.com/api")
//.constant('API_ROOT', "http://localhost/contasapp/api")

// PRODUCAO
.constant('API_ROOT', "https://lynkoapi.azurewebsites.net/api")


.constant('API_INTRANET', "http://localhost:5000/api")
//.constant('API_INTRANET', "https://smt.plandesk.com.br/api")

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 20;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular.module('inspinia').value('cgBusyDefaults',{
    message:'Carregando',
    templateUrl: 'app/components/common/loading.html'
  });

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
.config( [
    '$compileProvider',
    function( $compileProvider )
    {   
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
    }
]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

var angles = angular.module("angles", []);

  angles.chart = function (type) {
      return {
          restrict: "A",
          scope: {
              data: "=",
              options: "=",
              id: "@",
              width: "=",
              height: "=",
              resize: "=",
              chart: "@",
              segments: "@",
              responsive: "=",
              tooltip: "=",
              legend: "="
          },
          link: function ($scope, $elem) {
              var ctx = $elem[0].getContext("2d");
              var autosize = false;

              $scope.size = function () {
                  if ($scope.width <= 0) {
                      $elem.width($elem.parent().width());
                      ctx.canvas.width = $elem.width();
                  } else {
                      ctx.canvas.width = $scope.width || ctx.canvas.width;
                      autosize = true;
                  }

                  if($scope.height <= 0){
                      $elem.height($elem.parent().height());
                      ctx.canvas.height = ctx.canvas.width / 2;
                  } else {
                      ctx.canvas.height = $scope.height || ctx.canvas.height;
                      autosize = true;
                  }
              }

              $scope.$watch("data", function (newVal, oldVal) {
                  if(chartCreated)
                      chartCreated.destroy();

                  // if data not defined, exit
                  if (!newVal) {
                      return;
                  }
                  if ($scope.chart) { type = $scope.chart; }

                  if(autosize){
                      $scope.size();
                      chart = new Chart(ctx);
                  };

                  if($scope.responsive || $scope.resize)
                      $scope.options.responsive = true;

                  if($scope.responsive !== undefined)
                      $scope.options.responsive = $scope.responsive;

                  chartCreated = chart[type]($scope.data, $scope.options);
                  chartCreated.update();
                  if($scope.legend)
                      angular.element($elem[0]).parent().after( chartCreated.generateLegend() );
              }, true);

              $scope.$watch("tooltip", function (newVal, oldVal) {
                  if (chartCreated)
                      chartCreated.draw();
                  if(newVal===undefined || !chartCreated.segments)
                      return;
                  if(!isFinite(newVal) || newVal >= chartCreated.segments.length || newVal < 0)
                      return;
                  var activeSegment = chartCreated.segments[newVal];
                  activeSegment.save();
                  activeSegment.fillColor = activeSegment.highlightColor;
                  chartCreated.showTooltip([activeSegment]);
                  activeSegment.restore();
              }, true);

              $scope.size();
              var chart = new Chart(ctx);
              var chartCreated;
          }
      }
  }


  /* Aliases for various chart types */
  angles.directive("chart", function () { return angles.chart(); });
  angles.directive("linechart", function () { return angles.chart("Line"); });
  angles.directive("barchart", function () { return angles.chart("Bar"); });
  angles.directive("radarchart", function () { return angles.chart("Radar"); });
  angles.directive("polarchart", function () { return angles.chart("PolarArea"); });
  angles.directive("piechart", function () { return angles.chart("Pie"); });
  angles.directive("doughnutchart", function () { return angles.chart("Doughnut"); });
  angles.directive("donutchart", function () { return angles.chart("Doughnut"); });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }])
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
;

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 0px; margin-bottom: 0px; text-align: center;\"><img width=\"420px\" src=\"../../assets/images/icons/index3.jpg\"></div><h1 style=\"text-align: center; font-size: 36px;\">Como podemos ajudar?</h1></div></div></div><div style=\"height: 20px;\"></div><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/novo_ticket\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-tag fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Abertura de Ticket</h3><div style=\"height: 30px;\"><small>Abertura de chamado para a área de tecnologia</small></div></div></div></a></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/consultar_ticket\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-list fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Minhas Solicitações</h3><div style=\"height: 30px;\"><small>Acompanhe suas solicitações</small></div></div></div></a></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/ticket_projetobi\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-line-chart fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Solicitar Projeto BI</h3><div style=\"height: 30px;\"><small>Serviços disponíveis</small></div></div></div></a></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/login/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\" ng-if=\"controller.statusTela == 1\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-home\"></i> Identificação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 16px; margin-bottom: 30px;\"><img width=\"220px\" src=\"https://designing-world.com/apland-4.5.0/img/bg-img/hero-4.png\"></div></div></div><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 20px;\"><h2 style=\"font-family: \'Poppins\', sans-serif; font-weight: 600; font-size: 3rem;\">Olá, Bem vindo!</h2><p>Informe os dados abaixo para realizar o acesso ao portal de serviços.</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><div style=\"margin-top: 0px;\">&nbsp;</div><label class=\"col-form-label\">Opção de Acesso <span class=\"red\">*</span></label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.tipoAcesso\"><option value=\"1\">Usuário de Rede</option></select></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário de Rede <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" placeholder=\"Ex: X0000001\" ng-model=\"controller.registro.usuarioRede\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 2\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail cadastrado <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" placeholder=\"Ex: usuario@gmail.com\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Senha <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"12\" placeholder=\"*******\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Continuar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-home\"></i> Verificação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 16px; margin-bottom: 30px;\"><img width=\"220px\" src=\"https://designing-world.com/apland-4.5.0/img/bg-img/hero-4.png\"></div></div></div><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 20px;\"><h2 style=\"font-family: \'Poppins\', sans-serif; font-weight: 600; font-size: 3rem;\">Validação de Acesso</h2><p>Informe o código de acesso enviado no e-mail <b>{{ controller.registro.email }}</b>.</p></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Código de Acesso <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"4\" placeholder=\"0000\" ng-model=\"controller.registro.codigoAcesso\" class=\"form-control inputDisabledModal bigText\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-warning\" type=\"button\" style=\"min-width: 180px;\" ng-click=\"controller.voltarInicio()\"><i class=\"fa fa-arrow-left\"></i> Voltar</button> <button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 180px;\" ng-click=\"controller.validarAcesso()\"><i class=\"fa fa-arrow-right\"></i> Continuar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 4\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-bank\"></i> Formulário de cadastro</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99.999.999/9999-99\" maxlength=\"50\" disabled=\"\" placeholder=\"CNPJ\" ng-model=\"controller.registro.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Segmento <span class=\"red\">*</span></label><select disabled=\"\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.tipoEmpresa\"><option value=\"1\">Factoring</option><option value=\"2\">Securitizadora</option><option value=\"3\">FIDC</option><option value=\"4\">ESC</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão social <span class=\"red\">*</span></label> <input type=\"text\" placeholder=\"\" maxlength=\"200\" ng-model=\"controller.registro.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone para contato <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"20\" mask=\"(99)99999-9999\" ng-model=\"controller.registro.telefone\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"50\" mask=\"99999-999\" ng-model=\"controller.registro.Cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do responsável pelo cadastro <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.responsavelNome\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF do responsável <span class=\"red\">*</span></label> <input type=\"text\" mask=\"999.999.999-99\" maxlength=\"50\" ng-model=\"controller.registro.responsavelCpf\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cargo/Função</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.responsavelCargo\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Confirme seu e-mail <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" ng-model=\"controller.registro.confirmarEmail\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Senha para acesso <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"10\" ng-model=\"controller.registro.senha\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Confirme sua senha <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"10\" ng-model=\"controller.registro.confirmarSenha\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><button class=\"btn btn-md btn-warning\" type=\"button\" style=\"min-width: 160px;\" ng-click=\"controller.irInicio()\"><i class=\"fa fa-arrow-left\"></i> Voltar</button></div></div><div class=\"col-lg-9\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Enviar Cadastro</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 3\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-edit\"></i> Confirmação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 16px; margin-bottom: 30px;\"><h2>Parabéns, recebemos sua solicitação com sucesso.<br><br>Enviamos uma <b style=\"color: red;\">confirmação</b> para o e-mail informado e o procedimento para acesso.</h2></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.irLogin()\"><i class=\"fa fa-arrow-right\"></i> Ir para a tela de Login</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content ng-scope\"></div>");
$templateCache.put("app/minor/minor.html","");
$templateCache.put("app/components/common/content.html","<div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">Service Desk 0.1</div><div><strong>Copyright</strong> Service Desk &copy; 2020</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" src=\"assets\\images\\icons\\icon_rb.png\"> <span class=\"block m-t-md\"><strong class=\"font-bold\" style=\"color: white;\">Usuário</strong></span> <span class=\"text-muted text-xs block\">Administrador</span></div></div><div class=\"logo-element\">GRU</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tasks\"></i> <span class=\"nav-label\">Tickets</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.pendentes_ticket\">Pendentes</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pesquisa_ticket\">Pesquisar Histórico</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastro_ticket\">Registrar Novo Ticket</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-wrench\"></i> <span class=\"nav-label\">Configurações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li class=\"active\"><a href=\"#\" id=\"damian\" aria-expanded=\"true\">Ticket <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse in\" aria-expanded=\"true\" style=\"\"><li><a ui-sref=\"index.ticket_assunto_pesquisa\">Assuntos</a></li><li><a ui-sref=\"index.ticket_categoria_pesquisa\">Categorias</a></li><li><a ui-sref=\"index.localidade_pesquisa\">Localidades</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pesquisarusuario\">Usuários</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 10px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><table><tr style=\"font-family: Verdana, Geneva, Tahoma, sans-serif;\"><td ng-if=\"main.empresa.logoUrl != null && main.empresa.logoUrl != \'\'\"><div style=\"width: 140px; text-align: center;\"><img width=\"120px\" src=\"{{main.empresa.logoUrl}}\" style=\"margin-right: 10px;\"></div></td><td style=\"vertical-align: bottom;\"><div><b style=\"font-size: 17px;\">{{main.empresa.nome}}</b></div><div style=\"margin-top: 3px; font-size: 12px;\" ng-if=\"main.empresa.telefone != null\"><i class=\"fa fa-phone\"></i> {{main.empresa.telefone}}</div><div style=\"margin-top: 2px; font-size: 12px;\" ng-if=\"main.empresa.whatsapp != null\"><i class=\"fa fa-whatsapp\"></i> {{main.empresa.whatsapp}}</div><div style=\"margin-top: 2px; font-size: 12px;\" ng-if=\"main.empresa.email != null\"><i class=\"fa fa-inbox\"></i> {{main.empresa.email}}</div><div style=\"margin-top: 2px; font-size: 12px;\" ng-if=\"main.empresa.enderecoLogradouro != null\"><i class=\"fa fa-map-marker\"></i> {{main.empresa.enderecoLogradouro}}</div></td></tr></table><br></div></div></div></div>");
$templateCache.put("app/home/modal/detalhesSolicitacao.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\">Fechar</span></button><h4 class=\"modal-title\">Empresa ABCD Ltda.</h4><small class=\"font-bold\">Detalhes da solicitação de antecipação de recebíveis.</small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" value=\"Empresa ABCD Ltda.\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" value=\"01.203.423/0001-45\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" value=\"010002-100\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Endereço</label> <input type=\"text\" value=\"Rua Boa Vista, 230\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" value=\"São Paulo\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">UF</label> <input type=\"text\" value=\"SP\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" value=\"R$ 50.000,00\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo</label> <input type=\"text\" value=\"90 dias\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição da proposta</label> <input type=\"text\" value=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\">Enviar Proposta</button></div></div>");
$templateCache.put("app/home/servico/index.html","<style>\r\n    body {\r\n        font-family: \'Lucida Sans\', \'Lucida Sans Regular\', \'Lucida Grande\', \'Lucida Sans Unicode\', Geneva, Verdana, sans-serif;\r\n    }\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n    .imgProduto {        \r\n        cursor: pointer;\r\n        position: relative;\r\n        display: inline-block;\r\n    }\r\n    .imgProduto img {\r\n        width: 98%;\r\n    }\r\n    .overlay {        \r\n        width:100%;\r\n        height:100%;\r\n        text-align: center;\r\n        font-size: 16px;\r\n        display:none;\r\n        color: white;\r\n        padding-top: 120px;\r\n    }\r\n    .imgProduto:hover .overlay {\r\n        width:100%;\r\n        height:100%;\r\n        background:rgba(59, 59, 59, 0.5);\r\n        position:absolute;\r\n        top:0;\r\n        left:0;\r\n        display:inline-block;\r\n        -webkit-box-sizing:border-box;\r\n        -moz-box-sizing:border-box;\r\n        box-sizing:border-box;\r\n    }\r\n    .imgProdutoBody {\r\n        /*background-color: rgb(253, 253, 242); */\r\n        background-color: rgb(250, 250, 250);\r\n        padding-bottom: 15px;\r\n    }\r\n    .imgProdutoBodyDiv {\r\n        padding-left: 10px; \r\n        padding-right: 10px; \r\n        padding-top: 10px; \r\n        padding-bottom: 2px;\r\n    }\r\n    .imgProdutoTexto {        \r\n        margin-top: 3px;\r\n        text-align: center;\r\n    }\r\n    .textValor {\r\n        font-weight: 500;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"margin-top: 5px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"margin-bottom: 20px;\"><input type=\"text\" ng-model=\"controller.filtro.texto\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control inputDisabledModal\" placeholder=\"Pesquisar...\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div ng:repeat=\"p in controller.registros\" ng-if=\"$index % 4 == 0\" class=\"row\" style=\"margin-bottom: 8px;\"><div class=\"col-md-3\"><div class=\"ibox\"><div class=\"ibox-content product-box\"><div class=\"product-imitation\"><img src=\"{{controller.registros[$index].fotoUrl}}\" style=\"width: 223px; height: 223px; margin-top: 10px; margin-bottom: 10px;\"></div><div class=\"product-desc\"><span class=\"product-price\">{{controller.registros[$index].valorVendaTexto}}</span> <small class=\"text-muted\">Produto</small> <a href=\"#\" class=\"product-name\">{{controller.registros[$index].nome}}</a><div class=\"small m-t-xs\" ng-if=\"false\">Many desktop publishing packages and web page editors now.</div></div></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+1] != null\"><div class=\"ibox\"><div class=\"ibox-content product-box\"><div class=\"product-imitation\"><img src=\"{{controller.registros[$index+1].fotoUrl}}\" style=\"width: 223px; height: 223px; margin-top: 10px; margin-bottom: 10px;\"></div><div class=\"product-desc\"><span class=\"product-price\">{{controller.registros[$index+1].valorVendaTexto}}</span> <small class=\"text-muted\">Produto</small> <a href=\"#\" class=\"product-name\">{{controller.registros[$index+1].nome}}</a></div></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+2] != null\"><div class=\"ibox\"><div class=\"ibox-content product-box\"><div class=\"product-imitation\"><img src=\"{{controller.registros[$index+2].fotoUrl}}\" style=\"width: 223px; height: 223px; margin-top: 10px; margin-bottom: 10px;\"></div><div class=\"product-desc\"><span class=\"product-price\">{{controller.registros[$index+2].valorVendaTexto}}</span> <small class=\"text-muted\">Produto</small> <a href=\"#\" class=\"product-name\">{{controller.registros[$index+2].nome}}</a></div></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+3] != null\"><div class=\"ibox\"><div class=\"ibox-content product-box\"><div class=\"product-imitation\"><img src=\"{{controller.registros[$index+3].fotoUrl}}\" style=\"width: 223px; height: 223px; margin-top: 10px; margin-bottom: 10px;\"></div><div class=\"product-desc\"><span class=\"product-price\">{{controller.registros[$index+3].valorVendaTexto}}</span> <small class=\"text-muted\">Produto</small> <a href=\"#\" class=\"product-name\">{{controller.registros[$index+3].nome}}</a></div></div></div></div></div></div></div><br></div></div></div></div></div></div>");
$templateCache.put("app/home/servico/index_old.html","<style>\r\n    body {\r\n        font-family: \'Lucida Sans\', \'Lucida Sans Regular\', \'Lucida Grande\', \'Lucida Sans Unicode\', Geneva, Verdana, sans-serif;\r\n    }\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n    .imgProduto {        \r\n        cursor: pointer;\r\n        position: relative;\r\n        display: inline-block;\r\n    }\r\n    .imgProduto img {\r\n        width: 98%;\r\n    }\r\n    .overlay {        \r\n        width:100%;\r\n        height:100%;\r\n        text-align: center;\r\n        font-size: 16px;\r\n        display:none;\r\n        color: white;\r\n        padding-top: 120px;\r\n    }\r\n    .imgProduto:hover .overlay {\r\n        width:100%;\r\n        height:100%;\r\n        background:rgba(59, 59, 59, 0.5);\r\n        position:absolute;\r\n        top:0;\r\n        left:0;\r\n        display:inline-block;\r\n        -webkit-box-sizing:border-box;\r\n        -moz-box-sizing:border-box;\r\n        box-sizing:border-box;\r\n    }\r\n    .imgProdutoBody {\r\n        /*background-color: rgb(253, 253, 242); */\r\n        background-color: rgb(250, 250, 250);\r\n        padding-bottom: 15px;\r\n    }\r\n    .imgProdutoBodyDiv {\r\n        padding-left: 10px; \r\n        padding-right: 10px; \r\n        padding-top: 10px; \r\n        padding-bottom: 2px;\r\n    }\r\n    .imgProdutoTexto {        \r\n        margin-top: 3px;\r\n        text-align: center;\r\n    }\r\n    .textValor {\r\n        font-weight: 500;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"margin-top: 5px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"margin-bottom: 20px;\"><input type=\"text\" ng-model=\"controller.filtro.texto\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control inputDisabledModal\" placeholder=\"Pesquisar...\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div ng:repeat=\"p in controller.registros\" ng-if=\"$index % 4 == 0\" class=\"row\" style=\"margin-bottom: 8px;\"><div class=\"col-md-3\"><div class=\"imgProduto imgProdutoBody\"><div class=\"overlay\">{{controller.registros[$index].nome}}</div><div class=\"imgProdutoBodyDiv\"><img src=\"{{controller.registros[$index].fotoUrl}}\"></div><div class=\"imgProdutoTexto\"><b class=\"produtoTitulo\">{{controller.registros[$index].nome}}</b><br><b class=\"textValor\">{{controller.registros[$index].valorVendaTexto}}</b></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+1] != null\"><div class=\"imgProduto imgProdutoBody\"><div class=\"overlay\">{{controller.registros[$index+1].nome}}</div><div class=\"imgProdutoBodyDiv\"><img src=\"{{controller.registros[$index+1].fotoUrl}}\"></div><div class=\"imgProdutoTexto\"><b class=\"produtoTitulo\">{{controller.registros[$index+1].nome}}</b><br><b class=\"textValor\">{{controller.registros[$index+1].valorVendaTexto}}</b></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+2] != null\"><div class=\"imgProduto imgProdutoBody\"><div class=\"overlay\">{{controller.registros[$index+2].nome}}</div><div class=\"imgProdutoBodyDiv\"><img src=\"{{controller.registros[$index+2].fotoUrl}}\"></div><div class=\"imgProdutoTexto\"><b class=\"produtoTitulo\">{{controller.registros[$index+2].nome}}</b><br><b class=\"textValor\">{{controller.registros[$index+2].valorVendaTexto}}</b></div></div></div><div class=\"col-md-3\" ng-if=\"controller.registros[$index+3] != null\"><div class=\"imgProduto imgProdutoBody\"><div class=\"overlay\">{{controller.registros[$index+3].nome}}</div><div class=\"imgProdutoBodyDiv\"><img src=\"{{controller.registros[$index+3].fotoUrl}}\"></div><div class=\"imgProdutoTexto\"><b class=\"produtoTitulo\">{{controller.registros[$index+3].nome}}</b><br><b class=\"textValor\">{{controller.registros[$index+3].valorVendaTexto}}</b></div></div></div></div></div></div><br></div></div></div></div></div></div>");}]);